// extracted by mini-css-extract-plugin
export var attribution = "_9k-4";
export var authorName = "_9k-5";
export var quote = "_9k-3";
export var testimonial = "_9k-2";
export var trustedBy = "_9k-0";
export var trustedByLabel = "_9k-1";